// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"CarouselDoodle_mainContainer__2LstG","doodleContainer":"CarouselDoodle_doodleContainer__6iaNx"};